import {
  DesignAvatarChooser,
  DesignAvatarChooserProps,
} from '@components/design-avatar/design-avatar-chooser';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormDesignAvatarChooserProps<T> = FormFieldProps<DesignAvatarChooserProps, T>;

export function FormDesignAvatarChooserField<T>(props: FormDesignAvatarChooserProps<T>) {
  const formFieldProps = useFormField(props);

  return <DesignAvatarChooser {...props} {...formFieldProps} />;
}
